import { get } from 'lodash';
import { createPropsSelectorOrm } from '../utils';

export const getClaimsData = createPropsSelectorOrm((session, parcelCode) =>
  get(session.Claim.withId(parcelCode), 'ref')
);
